import { buildConfiguratorSearch } from "@cfg/configurator-ui";
import { useQuery } from "@tanstack/react-query";
import { Navigate, useParams } from "react-router";
import { useApp } from "../app-context.tsx";
import { DefaultEmptyState } from "./defaults.tsx";

/** Public read-only share link: resolves the token and opens the configurator with those params. */
export function SharePage() {
  const { token = "" } = useParams();
  const { api, brand } = useApp();
  const Empty = brand.slots?.EmptyState ?? DefaultEmptyState;
  const q = useQuery({ queryKey: ["share", token], queryFn: () => api!.getShared(token), enabled: !!api });
  if (!api) return <Empty title="Sharing needs the API" body="This deployment has no API configured." />;
  if (q.isLoading) return <p className="muted page">Opening shared design…</p>;
  if (q.isError || !q.data) return <Empty title="This link has expired or does not exist" />;
  const s = q.data;
  return <Navigate to={`/design/${encodeURIComponent(s.designId)}${buildConfiguratorSearch({ version: s.version, params: s.params })}`} replace />;
}
